module.exports = __webpack_public_path__ + "static/therapy-bab03e13c3a6e67da51f36dd525ae44e.png";